function transString(text)
{
    let jsonDecode = JSON.parse(text);
    let content = $('meta[name="locale"]').attr('content')

    return jsonDecode[content];
}